import storeConfig from './store';
import history from './utils/history';

/**
 * This file is used as a singleton object that holds top level
 * application module instances like the redux store
 */
export default {};

// create history and store here so they are not affected by HMR
export const store = storeConfig.configureStore(
  {
    app: {
      dialogs: [],
      notifications: [],
    },
  },
  history
);
